import produce from 'immer';
import * as actionTypes from '../actions/actionTypes';
import { createId } from '../../utils/storeUtils';
import { ApiError, UserGroup, UserGroupActions } from '../../types';

export interface UserGroupsReducer {
  userGroups: UserGroup[];
  selectedUserGroup?: UserGroup;
  loading: boolean;
  error: ApiError;
}

export const initialState: UserGroupsReducer = {
  userGroups: [],
  error: {
    status: false,
    message: null,
  },
  loading: false,
};

const reducer = (state: UserGroupsReducer = initialState, action: UserGroupActions): UserGroupsReducer => {
  switch (action.type) {
    case actionTypes.USER_GROUPS_REQUEST_START:
      return produce(state, draft => {
        draft.loading = true;
      });
    case actionTypes.USER_GROUPS_GET_SUCCESS:
      return produce(state, draft => {
        draft.loading = false;
        draft.error = initialState.error;
        draft.userGroups = action.userGroups;
      });
    case actionTypes.USER_GROUPS_REQUEST_ERROR:
      return produce(state, draft => {
        draft.loading = false;
        draft.error.message = action.errorMessage || null;
        draft.error.status = true;
      });
    case actionTypes.USER_GROUP_ADD_EMPTY_GROUP: {
      const existingIds = state.userGroups.map(ug => ug.id);
      let id: string;
      do {
        id = createId(8);
      } while (existingIds.includes(id));
      return produce(state, draft => {
        draft.loading = false;
        draft.userGroups.push({
          name: '',
          default_user_roles: [],
          inherited_invoicing_account: {
            name: '',
          },
          modified: true,
          newItem: true,
          id,
        });
      });
    }
    case actionTypes.USER_GROUP_DELETE_GROUP:
      return produce(state, draft => {
        draft.loading = false;
        draft.error = initialState.error;
        draft.userGroups = draft.userGroups.filter(ug => ug.id !== action.id);
      });
    case actionTypes.USER_GROUP_UPDATE_GROUP:
      return produce(state, draft => {
        draft.loading = false;
        draft.error = initialState.error;
        draft.userGroups = draft.userGroups.map(group => (group.id === action.userGroupId ? action.userGroup : group));
      });
    case actionTypes.USER_GROUP_SELECT_GROUP:
      return produce(state, draft => {
        draft.selectedUserGroup = draft.userGroups.find(ug => ug.id === action.userGroupId);
      });
    case actionTypes.USER_GROUP_SELECTED_CLEAR:
      return produce(state, draft => {
        draft.selectedUserGroup = initialState.selectedUserGroup;
      });
    default:
      return state;
  }
};

export default reducer;
